import { render, staticRenderFns } from "./apply_collection.vue?vue&type=template&id=54d5ad12&scoped=true"
import script from "./apply_collection.vue?vue&type=script&lang=js"
export * from "./apply_collection.vue?vue&type=script&lang=js"
import style0 from "./apply_collection.vue?vue&type=style&index=0&id=54d5ad12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5ad12",
  null
  
)

export default component.exports